import { useCallback, useEffect, useRef } from 'react';

export default function useThrottledCallback(callback, dependencyArray, { wait, argumentsReducer = null }) {
  const argsRef = useRef([]);
  const timeout = useRef(0);

  function cleanup() {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
  }

  useEffect(() => cleanup, []);

  return useCallback((...arg) => {
    argsRef.current = [...argsRef.current, arg];

    if (timeout.current) {
      return;
    }

    timeout.current = setTimeout(() => {
      if (argsRef.current.length) {
        if (argumentsReducer) {
          const singleReducedArgument = argumentsReducer(argsRef.current.map(argsList => argsList[0]));
          callback(singleReducedArgument);
        } else {
          const latestCallArguments = argsRef.current[argsRef.current.length - 1];
          callback(...latestCallArguments);
        }
        argsRef.current = [];
      }
      timeout.current = 0;
    }, wait);
  }, dependencyArray);
}
